import { render } from "./TheFeature.vue?vue&type=template&id=0eb34a88"
const script = {}

import "./TheFeature.vue?vue&type=style&index=0&id=0eb34a88&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__